import { Component, OnInit, Input } from '@angular/core';
import { ResultAlertError } from '@app/enums/errors.enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PassengerService } from '@app/services/micro/passenger.service';
import { GlobalsService } from '@services/micro/globals.service';
import { Passenger } from '@app/models/micro/passenger.model';

/**
 * Componente para mostrar un modal de errores personalizable.
 * Este componente permite mostrar mensajes de error en un modal con opciones configurables,
 * como título, mensaje, código de error, iconos, botones, colores, entre otros.
 * Además, gestiona la selección de pasajeros y su relación con la reserva actual.
 */
@Component({
  selector: 'app-errors-modal-ckn',
  templateUrl: './errors-modal-ckn.component.html',
  styleUrls: ['./errors-modal-ckn.component.scss'],
  standalone: false,
})
export class ErrorsModalCknComponent implements OnInit {
  /**
    Título del error.
  **/
  @Input() public titleError = '';

  /**
      Mensaje de error.
    **/
  @Input() public msgError = '';

  /**
      Código del error.
    **/
  @Input() public codeError = '';

  /**
      Identificador único del error.
    **/
  @Input() public uuidError = '';

  /**
      Indica si se debe imprimir una tarjeta.
    **/
  @Input() public printCard = '';

  /**
      Color de fondo del modal.
    **/
  @Input() public backgroundColorModal = 'am-blue-premium';

  /**
      Indica si se muestra el botón de acción.
    **/
  @Input() public showButton = true;

  /**
      Texto del botón de acción.
    **/
  @Input() public buttonCopy = '';

  /**
      Indica si se muestra un ícono o imagen.
    **/
  @Input() public showIconImage = true;

  /**
      URL del ícono o imagen.
    **/
  @Input() public urlIconImage = '';

  /**
      Color de la fuente del botón.
    **/
  @Input() public colorFontButton = '';

  /**
      Color de fondo del botón.
    **/
  @Input() public backGroundButton = '';

  /**
      Tamaño del modal.
    **/
  @Input() public sizeModal = '';

  /**
      Peso de la fuente del título del error.
    **/
  @Input() public fontWeightTitleError = '';

  /**
      Imagen adicional para mostrar en el modal.
    **/
  @Input() public image = '';

  /**
      Indica si se muestra el botón de cancelar.
    **/
  @Input() public showCancelButton = false;

  /**
      Texto del botón de cancelar.
    **/
  @Input() public cancelButtonText = '';

  /**
      Texto del botón de cancelar.
    **/
  @Input() public showListPassengers = true;

  /**
      Whether this is a DOB mismatch confirmation modal (affects layout/styling).
    **/
  @Input() public isDobModal = false;

  /**
      Pre-translated DOB label (e.g. "Fecha de nacimiento en pasaporte:").
    **/
  @Input() public dobLabel = '';

  /**
      DOB value to display (e.g. "02/02/1994").
    **/
  @Input() public dobValue = '';

  /**
      Whether this is a passport number ambiguity confirmation modal (affects layout/styling).
    **/
  @Input() public isPassportAmbiguityModal = false;

  /**
      Pre-translated passport number label (e.g. "Número de pasaporte escaneado:").
    **/
  @Input() public passportNumberLabel = '';

  /**
      Scanned passport number value to display for visual validation.
    **/
  @Input() public passportNumberValue = '';

  /**
      Lista de pasajeros seleccionados.
    **/
  passengerSelected: Passenger[];

  /**
      Pasajero actual.
    **/
  currentPassenger: Passenger;

  /**
      Lista de todos los pasajeros.
    **/
  passengers: Array<Passenger> = [];

  /**
      Número de pasajeros en la reserva.
    **/
  noPassPnr: number;

  /**
      Número de pasajeros seleccionados.
    **/
  noPassSele: number;

  /**
      Indica si todos los pasajeros están seleccionados.
    **/
  isAllPass = false;

  constructor(
    private modalService: NgbActiveModal,
    private _passengerService: PassengerService,
    private global: GlobalsService
  ) {}

  ngOnInit(): void {
    this.passengerSelected = this._passengerService.getPassengerSelection();
    this.noPassPnr = this.global.reservation.passengers.length;
    this.noPassSele = this._passengerService.getPassengerSelection().length;

    if (this.noPassPnr == this.noPassSele) {
      this.isAllPass = true;
    }
  }
  /**
    Cierra el modal con una operación de aceptación.
    Este método se ejecuta cuando el usuario hace clic en el botón de acción.
    @return void - No retorna ningún valor, pero cierra el modal con la operación `ResultAlertError.ACCEPT`.
  **/
  actionBtn() {
    this.modalService.close({ operation: ResultAlertError.ACCEPT });
  }
  /**
    Descarta el modal sin realizar ninguna operación.
    Este método se ejecuta cuando el usuario hace clic en el botón de cancelar.
    @return void - No retorna ningún valor, pero descarta el modal sin realizar ninguna acción adicional.
  **/
  actionBtnCancel() {
    this.modalService.dismiss();
  }
}
